import axios from '../../../axios'

export default {
  getTimeLineRange: function (railobjectId, dateFrom, dateTo) {
    return axios
      .get('switch/measurements/timelinerange/' + railobjectId, {
        params: {
          dtFrom: dateFrom,
          dtTo: dateTo
        }
      })
  },
  getChildMeasurements: function (railobjectId, measurementId) {
    return axios
      .get('switch/measurements/timelinerange/' + railobjectId + '/child/' + measurementId, {})
  },
  getTimeLineLastN: function (railObjectId, direction, numberItems, dateFrom, backwards) {
    return axios
      .get('switch/measurements/timelineLastN/' + railObjectId, {
        params: {
          Direction: direction,
          NrItems: numberItems,
          dtFrom: dateFrom,
          backwards: backwards
        }
      })
  },
  getLastAlarm (railObjectId) {
    return axios
      .get('switch/measurements/lastAlarm/' + railObjectId)
  },
  getTimeLineLastNAlarms: function (railObjectId, nrAlarms, nrItems, dateFrom, backwards) {
    return axios
      .get('switch/measurements/timelineLastNAlarms/' + railObjectId, {
        params: {
          NrAlarms: nrAlarms,
          NrItems: nrItems,
          dtFrom: dateFrom,
          backwards: backwards
        }
      })
  },
  getMeasurement: function (railobjectId, measurementid, withReference) {
    return axios
      .get('switch/measurements/' + railobjectId + '/' + measurementid, {
        params: {
          withReference: withReference
        }
      })
  },
  getReferenceHistory: function (railobjectId) {
    return axios
      .get('switch/measurements/' + railobjectId + '/referenceHistory')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/switch/MeasurementsApi.js